import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flag h-screen w-screen flex flex-col items-center justify-center text-center p-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "text-16px xl:text-24px text-black-lp-300 font-bold mb-2 xl:mb-4" }, " Sanggahan anda telah diterima ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "text-12px xl:text-20px text-gray-lp-800 mx-0 md:mx-24 lg:mx-56 xxl:mx-76" }, " Terimakasih atas sanggahan yang telah anda kirim, mohon tunggu sebentar, sanggahan akan segera diproses. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isError && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          imageWidth: "40 xl:w-72 mb-6 xl:mb-10",
          titleStyles: "text-16px xl:text-24px mb-2 xl:mb-4 -my-2",
          messageStyles: "text-12px xl:text-20px mx-0 md:mx-24 lg:mx-56 xxl:mx-76 -mt-1 -mb-4"
        }, null, 8, ["errorType"]))
      : (!_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("img", {
              src: require('@/app/ui/assets/svg/sended.svg'),
              class: "w-40 xl:w-72 mb-6 xl:mb-10",
              alt: "sended"
            }, null, 8, ["src"]),
            _hoisted_2,
            _hoisted_3
          ], 64))
        : _createCommentVNode("", true)
  ]))
}